<div *ngIf="quizSubmitted">
  <p style="color:black;font-size:20px;font-weight:500;text-align:center;">Quiz Page Not Found</p>
  
  <button type="button" class="btn btn-outline-success btn-sm" (click)="btnClose()" style="width:50%;margin-left:25%;margin-right: 25%;font-size:20px;">Close Now</button>
</div>



<div *ngIf="!quizSubmitted">
  <p style="color:black;font-size:20px;font-weight:500;text-align:center;">Page Not Found</p>
</div>
